import { render, staticRenderFns } from "./ValuerWorkload.vue?vue&type=template&id=3ed1e9cf&scoped=true&"
import script from "./ValuerWorkload.vue?vue&type=script&lang=js&"
export * from "./ValuerWorkload.vue?vue&type=script&lang=js&"
import style0 from "./ValuerWorkload.vue?vue&type=style&index=0&id=3ed1e9cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed1e9cf",
  null
  
)

/* custom blocks */
import block0 from "./ValuerWorkload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports